<script lang="ts">
  /**
   * Compact toolbar button styled for the dark-chrome top bar (bg-surface-5).
   * Used for tool-mode switches (Select / Road / Store) and the theme cycle —
   * any momentary action or persistent toggle that lives in the toolbar.
   *
   * `active=true` paints the chrome-accent treatment; matches the spec's
   * "selected tab" feel — subtle accent wash + accent text rather than a
   * heavy CTA bg, so an active tool reads as "current state" not "click me".
   */
  interface Props {
    /** Single-glyph icon. Empty string for label-only buttons. */
    ico: string
    label: string
    /** Persistent toggled state (e.g. the active tool). Defaults false. */
    active?: boolean
    /** Tooltip; defaults to label. */
    title?: string
    /** Disable interaction; greys out without removing from layout. */
    disabled?: boolean
    onclick: () => void
  }

  const {
    ico,
    label,
    active = false,
    title,
    disabled = false,
    onclick,
  }: Props = $props()
</script>

<button
  type="button"
  class="rounded px-2 py-1 text-xs transition disabled:opacity-40 {active
    ? 'bg-accent/20 text-accent'
    : 'text-chrome-text-2 hover:bg-surface-3 hover:text-chrome-text'}"
  title={title ?? label}
  aria-pressed={active}
  {disabled}
  {onclick}
>
  {#if ico}
    <span aria-hidden="true">{ico}</span>
    {#if label}
      <span class="ml-1">{label}</span>
    {/if}
  {:else}
    {label}
  {/if}
</button>
